import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import * as Redux from 'redux'

interface IUserState {
  username: string
  firstname: string
  lastname: string
  email: string
  error: string
}

interface IAdminAction extends IReducerAction {
  type: string
  user?: IUserState
}

const ActionTypes = {
  LISTUSERS: 'admin/LISTUSERS',
  ADDUSER: 'admin/ADDUSER',
  DELETEUSER: 'admin/DELETEUSER',
}

const initialState: IUserState = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  error: ''
}

const functionalReducer = new FunctionalReducer<IUserState, IAdminAction>(initialState)
  .whenTypeIs(ActionTypes.LISTUSERS, () => {
    return {
      username: initialState.username,
      firstname: initialState.firstname,
      lastname: initialState.lastname,
      email: initialState.email,
      error: initialState.error,
    }
  })
  .whenTypeIs(ActionTypes.ADDUSER, () => {
    return {
      username: '',
      firstname: '',
      lastname: '',
      email: '',
      error: ''
    }
  })

export {
  functionalReducer,
  ActionTypes,
  IUserState,
  IAdminAction
}



// WEBPACK FOOTER //
// ./src/app/redux/Admin/reducer/index.ts